import { Classes } from '@blueprintjs/core';
import { Separator } from '@radix-ui/react-dropdown-menu';
import cx from 'classnames';
import React__default from 'react';

var Divider = function Divider() {
  var classes = cx(Classes.MENU_DIVIDER);
  return /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(Separator, {
    className: classes
  }));
};

export { Divider };
//# sourceMappingURL=dropdown-menu-divider.js.map
